// Formatting helpers shared by the inbox request lists (DJB-265/267). All
// dates from the backend are Brussels-local strings; they are read from the
// string parts so no time zone shift can happen.

// "2026-10-17" -> "17/10/2026"
export const formatDate = (isoDate) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

// "2026-10-17T14:03:09" -> "17/10/2026 14:03:09" (seconds optional in input)
export const formatDateTime = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(iso || '');
  return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}:${m[6] || '00'}` : '';
};

// Today's date as a Brussels day (yyyy-MM-dd): the day summary is cut on
// Brussels midnight, so "today" has to be too
export const todayBrussels = (now = new Date()) =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Brussels',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);

// Where a song was requested: "Machinenaam - Gemeente" for a known jukebox,
// otherwise the free café text the visitor typed
export const requestLocation = (item) => {
  if (item.machineName) {
    return item.machineCity ? `${item.machineName} - ${item.machineCity}` : item.machineName;
  }
  return item.cafe || '';
};

// A mailto: address: encoded so visitor text cannot smuggle in extra headers,
// with the @ kept readable
export const mailtoAddress = (email) => encodeURIComponent(email).replace(/%40/g, '@');

// "2026-10-17T14:03:09" -> "14:03:09" (DJB-279: the day is the group header,
// so a card only shows the time)
export const formatTime = (iso) => {
  const m = /^\d{4}-\d{2}-\d{2}[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(iso || '');
  return m ? `${m[1]}:${m[2]}:${m[3] || '00'}` : '';
};
